import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { css } from 'emotion';
var PureDescription = /*#__PURE__*/function (_React$Component) {
  _inherits(PureDescription, _React$Component);
  function PureDescription() {
    _classCallCheck(this, PureDescription);
    return _possibleConstructorReturn(this, _getPrototypeOf(PureDescription).apply(this, arguments));
  }
  _createClass(PureDescription, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        question = _this$props.question,
        description = _this$props.question.description;
      return React.createElement("div", {
        className: descriptionWrapper,
        dangerouslySetInnerHTML: {
          __html: sanitizeHtml((window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Description")] : description) || '')
        }
      });
    }
  }]);
  return PureDescription;
}(React.Component);
export { PureDescription as default };
var descriptionWrapper = /*#__PURE__*/css("background:transparent;color:var(--text-color-secondary);p{&:not(:first-of-type){display:block;margin-top:15px !important;}}");